module.exports = __webpack_public_path__ + "static/media/kibana.83eb195f.svg";